import { render } from "./Toekomstig.vue?vue&type=template&id=85067af0&scoped=true&ts=true"
import script from "./Toekomstig.vue?vue&type=script&lang=ts"
export * from "./Toekomstig.vue?vue&type=script&lang=ts"

import "./Toekomstig.vue?vue&type=style&index=0&id=85067af0&scoped=true&lang=css"

import exportComponent from "/tmp/nginx/vue-single-page-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85067af0"]])

export default __exports__